import { createCustomEnum } from "./customEnum";

const AmexOptBlueOrEsaTypes = createCustomEnum({
	None: {
		value: "None",
		name: "none",
		displayName: "None",
	},
	AmexOptBlue: {
		value: "OptBlue",
		name: "amexType",
		displayName: "Opt Blue",
	},
	ESA: {
		value: "Esa",
		name: "amexType",
		displayName: "ESA",
	},
});

export const AmexOptBlueOrEsaTypesByValue = createCustomEnum({
	None: {
		value: 0,
		name: "none",
		displayName: "None",
	},
	ESA: {
		value: 1,
		name: "Esa",
		displayName: "ESA",
	},
	AmexOptBlue: {
		value: 2,
		name: "OptBlue",
		displayName: "Opt Blue",
	},
});

export default AmexOptBlueOrEsaTypes;
